export default "__VITE_ASSET__Bt17CpLZ__"